var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPremiumContributionCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.334 9.168h1.667v1.667H6.334V9.168zm0 3.333h1.667v1.667H6.334v-1.667zm3.333-3.333h1.667v1.667H9.667V9.168zm0 3.333h1.667v1.667H9.667v-1.667zm3.334-3.333h1.666v1.667h-1.666V9.168zm0 3.333h1.666v1.667h-1.666v-1.667z",
    fill: "#FF6C01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.667 18.335h11.666c.92 0 1.667-.748 1.667-1.667V5.001c0-.919-.747-1.666-1.667-1.666h-1.666V1.668H13v1.667H8V1.668H6.333v1.667H4.667C3.747 3.335 3 4.082 3 5v11.667c0 .92.748 1.667 1.667 1.667zM16.333 6.668l.001 10H4.667v-10h11.666z",
    fill: "#FF6C01"
  })));
}

export default SvgIconPremiumContributionCalendar;